import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { OUTCOMES } from "@/lib/data";

// Anonymous, third-person facts drawn from rccdinc.com — not invented quotes.
export const Testimonials = () => {
  return (
    <section id="outcomes" className="py-24 lg:py-40 bg-paper">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Section · 07 — Notable outcomes</span>
            <h2 className="font-display text-4xl lg:text-6xl text-ink mt-4 leading-[1.02] tracking-[-0.02em]">
              What gets <em className="font-light">delivered.</em>
            </h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-7 text-base lg:text-lg text-foreground/70 leading-relaxed">
            A few of the public-record outcomes from the programs RCCD has been part of — most notably the New Model Colony consortium in the City of Ontario.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
          {OUTCOMES.map((o, i) => (
            <motion.article
              key={o.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group bg-secondary border border-border p-8 lg:p-10 hover:border-clay transition-colors flex flex-col"
            >
              <div className="flex items-start justify-between">
                <Quote className="h-7 w-7 text-clay/40 group-hover:text-clay transition-colors" />
                <span className="mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">{String(i+1).padStart(2,'0')}</span>
              </div>
              <h3 className="font-display text-2xl lg:text-3xl text-ink mt-6 leading-tight tracking-[-0.01em]">
                {o.title}
              </h3>
              <p className="mt-4 text-base text-foreground/75 leading-relaxed">{o.detail}</p>
              <div className="mt-auto pt-6 mono text-[10px] uppercase tracking-[0.22em] text-clay">
                {o.label}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
